export const CUSTOMER_STORIES_PLATFORMS = ["agents", "creative", "api"] as const;

export type CustomerStoriesPlatform = (typeof CUSTOMER_STORIES_PLATFORMS)[number];

export const CUSTOMER_STORIES_PLATFORM_LABELS: Record<CustomerStoriesPlatform, string> = {
  agents: "ElevenAgents",
  creative: "ElevenCreative",
  api: "ElevenAPI",
};

export const CUSTOMER_STORIES_PLATFORM_OPTIONS = CUSTOMER_STORIES_PLATFORMS.map(platform => ({
  label: CUSTOMER_STORIES_PLATFORM_LABELS[platform],
  value: platform,
}));
